declare var google: any;

export default class Translator {
    private $selected: JQuery;
    private $langs: JQuery;

    private $combo: JQuery;

    private getGLang(): string {
        var val = document['cookie'].match('(^|;) ?googtrans=([^;]*)(;|$)');

        return val ? val[2].split('/')[2] : null;
    }

    private fireGEvent(): void {
        try {
            if ((<any>document).createEventObject) {
                const evt = (<any>document).createEventObject();
                (<any>this.$combo[0]).fireEvent('onchange', evt);
            } else {
                const evt = document.createEvent('HTMLEvents');
                evt.initEvent('change', true, true);
                (<any>this.$combo[0]).dispatchEvent(evt);
            }

        } catch (e) { }
    }

    private setGLang(code: string): void {
        (<any>this.$combo[0]).value = code;
        this.fireGEvent();
    }

    private showLang(code: string): void {
        this.$langs.removeClass('languages__item--selected');
        this.$langs.filter('[data-lang="' + code + '"]').addClass('languages__item--selected');

        switch (code) {
            case 'uk':
                code = 'ua';
                break;
        }

        this.$selected.text(code);
    }

    public doLang(code: string): void {
        this.showLang(code);
        this.setGLang(code);
        this.setGLang(code);
    }

    public initGt(success: () => void): void {
        (<any>window).googleTranslateElementInit = () => {
            let params = {
                pageLanguage: 'pl',
                autoDisplay: false
            };

            new google.translate.TranslateElement(params, 'google_translate_element');

            let timer = setInterval(() => {
                this.$combo = $('.goog-te-combo');

                if (this.$combo.length) {
                    clearInterval(timer);
                    timer = null;

                    success();
                }
            }, 500);
        }

        let $gte = $('<div id="google_translate_element">');
        $gte.appendTo($('body'));

        $.getScript('//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
    }

    private initHtml(): void {
        this.initGt(() => {
            let lang = this.getGLang();

            if (lang == null) {
                lang = 'pl';
            }

            this.showLang(lang);

            const m = location.hash.match(/lang=(\w\w)/);

            if (m) {
                this.doLang(m[1]);
            }

            $languages.addClass('languages--inited');
        });

        let $languages = $('.header .languages');
        this.$selected = $('.header__lang-selected', $languages);
        this.$langs = $('.languages__item', $languages);

        this.$langs.each((i, el) => {
            let $el = $(el);
            let code = $el.data('lang');

            $el.addClass('languages__item--' + code);

            $el.click((e) => {
                e.preventDefault();

                this.doLang(code);
            });
        });
    }

    public static init(): void {
        const t = new Translator();
        t.initHtml();
    }
}
